// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__DWD9X","gfeWrapper":"CalendarEvent_gfeWrapper__WCXDP"};